module.exports = __webpack_public_path__ + "img/icon_koerpliche_aktivitaet.312ce59e.svg";